<template>
  <v-container fluid class="my-5">
    <MesaDirectivaAcuerdos />
  </v-container>
</template>

<script>
import MesaDirectivaAcuerdos from '@/components/mesaDirectiva/MesaDirectivaAcuerdos.vue'

export default {
  name: 'mesa_directiva_acuerdos',
  components: {
    MesaDirectivaAcuerdos
  }
}
</script>
